import vars from '../_vars.js';
import {elementSize} from "@soinproduction/kit";

document.addEventListener("DOMContentLoaded", function () {
    const {header} = vars;
    elementSize(header, 'header-height', 'height');
    elementSize(header.querySelector('.header__nav'), 'nav-height', 'height');
});
